import { Skeleton } from "@/components/ui/skeleton";

/**
 * Full-page loading fallback for route-level code splitting.
 * Displays a skeleton that matches the general page layout to minimize CLS.
 */
export function PageLoadingFallback() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header skeleton */}
      <div className="sticky top-0 z-50 border-b border-card-bg-medium bg-header-bg backdrop-blur-xl">
        <div className="container mx-auto flex items-center justify-between px-4 h-16 md:h-20">
          <Skeleton className="w-24 h-8" />
          <Skeleton className="w-32 h-10 rounded-full" />
        </div>
      </div>

      {/* Main content skeleton */}
      <div className="max-w-[1440px] mx-auto px-2 sm:px-6 md:px-8 lg:px-6">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 py-4">
          {/* Left side - Chart area */}
          <div className="flex-1 lg:max-w-[969px]">
            <div className="flex flex-col gap-6 lg:gap-8">
              {/* Chart card skeleton */}
              <div className="rounded-card border border-card-bg-medium bg-card-bg-light p-6 lg:p-8">
                <Skeleton className="w-40 h-6 mb-4" />
                <Skeleton className="w-full h-[260px] rounded-lg" />
              </div>
            </div>
          </div>

          {/* Right side - Swap card skeleton (desktop only) */}
          <div className="hidden lg:block flex-shrink-0 w-[400px]">
            <div className="rounded-card border border-card-bg-medium bg-card-bg-light p-6">
              <Skeleton className="w-full h-[300px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageLoadingFallback;
